import React, { useState, useEffect } from "react";
import axios from "axios";
import config from "../../config";

export default function Farmer() {
    const baseUrl = config.baseUrl;

    // Farmer data states
    const [farmer, setFarmer] = useState({});
    const [tab, setTab] = useState("details"); // Default tab
    const [editMode, setEditMode] = useState(false); // Edit mode toggle

    // Get farmer ID from URL
    const farmerId = window.location.pathname.split("/").pop();

    // Fetch farmer data
    useEffect(() => {
        axios
            .get(`${baseUrl}/farmer/${farmerId}`)
            .then((response) => setFarmer(response.data))
            .catch((error) => console.error(error));
    }, [farmerId]);

    // Handle form input changes
    const handleInputChange = (e) => {
        setEditMode(true); // Enable edit mode when input changes
        const { name, value } = e.target;
        setFarmer((prevFarmer) => ({
            ...prevFarmer,
            [name]: value,
        }));
    };

    const handleUpdate = () => {
        setEditMode(!editMode);

        console.log("Send a PUT request to update farmer details");
    };

    // Handle form submission
    const handleFormSubmit = (e) => {
        e.preventDefault();
        axios
            .put(`${baseUrl}/farmer/${farmerId}`, farmer)
            .then((response) => {
                setEditMode(false); // Disable edit mode after update
                alert("Farmer details updated successfully!");
            })
            .catch((error) => console.error(error));
    };

    return (
        <>
            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 rounded">
                <div className="rounded-t mb-0 px-4 py-3 border-0 bg-white min-h-screen">
                    <div className="flex flex-wrap items-center">
                        <div className="relative w-full px-4 max-w-full flex-grow flex-1 flex justify-between">
                            <h3 className="font-semibold text-lg text-blueGray-700">
                                Farmer Information
                            </h3>
                            <button
                                className={`px-4 py-2 rounded ${editMode ? "btn-primary" : "btn-primary-disabled"}`}
                                onClick={handleUpdate}
                                disabled={!editMode}
                            >
                                UPDATE
                            </button>
                        </div>
                    </div>

                    {/* Tab Navigation */}
                    <div className="my-4">
                        <nav className="flex space-x-4 border-b-2 pb-2 overflow-x-scroll">
                            {["details", "payments", "products", "orders", "deliveries"].map((t) => (
                                <button
                                    key={t}
                                    className={`px-3 py-2 rounded border-0 ${tab === t ? "bg-gray-200  " : ""}`}
                                    onClick={() => setTab(t)}
                                >
                                    {t.charAt(0).toUpperCase() + t.slice(1)}
                                </button>
                            ))}
                        </nav>
                    </div>

                    {/* Tab Content */}
                    <div className="block w-full overflow-x-auto">
                        {tab === "details" && (
                            <>
                                <div className="flex">
                                    <h4 className="font-bold mb-2">Farmer Details</h4>
                                </div>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="inputGroup-sizing-default">Name</span>
                                    </div>
                                    <input type="text" name="name" value={farmer.name} onChange={handleInputChange} class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default"/>
                                </div>
                                
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="inputGroup-sizing-default">Email</span>
                                    </div>
                                    <input type="text" name="email" value={farmer.email} onChange={handleInputChange} class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default"/>
                                </div>

                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="inputGroup-sizing-default">Phone</span>
                                    </div>
                                    <input type="text" name="phone" value={farmer.phone} onChange={handleInputChange} class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default"/>
                                </div>

                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="inputGroup-sizing-default">Address</span>
                                    </div>
                                    <input type="text" name="address" value={farmer.address} onChange={handleInputChange} class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default"/>
                                </div>
                            </>
                        )}

                        {tab === "payments" && (
                            <div>
                                <h4 className="font-bold mb-2">Payment History</h4>
                                {/* Replace this with actual payment data */}
                                <ul>
                                    <li>Payment 1: $500</li>
                                    <li>Payment 2: $200</li>
                                    <li>Payment 3: $300</li>
                                </ul>
                            </div>
                        )}

                        {tab === "products" && (
                            <div>
                                <h4 className="font-bold mb-2">Products Offered</h4>
                                {/* Replace this with actual product data */}
                                <ul>
                                    <li>Product 1</li>
                                    <li>Product 2</li>
                                    <li>Product 3</li>
                                </ul>
                            </div>
                        )}

                        {tab === "orders" && (
                            <div>
                                <h4 className="font-bold mb-2">Order History</h4>
                                {/* Replace this with actual order data */}
                                <ul>
                                    <li>Order 1</li>
                                    <li>Order 2</li>
                                    <li>Order 3</li>
                                </ul>
                            </div>
                        )}

                        {tab === "deliveries" && (
                            <div>
                                <h4 className="font-bold mb-2">Delivery Details</h4>
                                {/* Replace this with actual delivery data */}
                                <ul>
                                    <li>Delivery 1</li>
                                    <li>Delivery 2</li>
                                    <li>Delivery 3</li>
                                </ul>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}
